export enum UnidadMedida {
  CM,
  INCHES
}

export const getUnidadMedida = (unidad: UnidadMedida, medida: number) => {
  switch(unidad) {
    case UnidadMedida.INCHES :
        return Math.round(medida / 2.54);
    default :
      return medida;
  }
}
